import React from 'react'
import { styled } from '@mui/material/styles'
import ListItem from '@mui/material/ListItem'
import DealItemDetails from './DealItemDetails'

const StyledListItem = styled(ListItem)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  margin: '5px',
  width: 'calc(100% - 10px)',
  borderRadius: '5px',
}))

const DealListItem = React.memo(
  ({ item }: { item: any }) => {
    return (
      <StyledListItem>
        <DealItemDetails deal={item} />
      </StyledListItem>
    )
  },
  (prevProps, nextProps) => prevProps.item.SK === nextProps.item.SK
)

export default DealListItem
